import { makeStyles } from '@material-ui/core/styles'
import { COLORS } from '../../COLORS'

export const useStyles = makeStyles((theme) => ({
  offerForm: {
    marginBottom: 40
  },
  inwrap: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  msgtitle: {
    color: COLORS.BLUE,
    fontSize: 16,
    fontWeight: 800
  },
  intro: {
    lineHeight: '1.5',
    fontSize: '1.1rem',
    margin: '2rem 0'
  },
  msgbody:{
    whiteSpace: "pre-line"
  },
  fileArea: {
    display: 'flex',
    flexDirection: 'column',
  }
}))
